import * as CommentsSelectors from '../comments';
import * as FilerrsSelectors from '../filerrs';

export const getReview = (state = {}, commentIds) => {
    const filerrIds = FilerrsSelectors.getFilerrIds(state);
    const commentsCountByFilerrId = CommentsSelectors.getCommentsCountByCommentIdGroupedByFilerrId(state, commentIds);

    return filerrIds.reduce(
        (accumulator, filerrId) => {
            const filerr = FilerrsSelectors.getFilerrById(state, filerrId);

            return [
                ...accumulator,
                {
                    filerr,
                    commentsCount: commentsCountByFilerrId[filerrId] || 0
                }
            ];
        },
        []
    );
};
